import { useStoreDialog } from "../state/useStoreDialogs";
import DialogHeader from "./DialogHeader";

export default function Discover() {
  const navTo = useStoreDialog((state) => state.navTo);
  const goHome = useStoreDialog((state) => state.goHome);
  const editMode = false;
  return (
    <div className="h-full w-full bg-purple-400">
      <DialogHeader
        title={editMode ? "Edit Discover" : "Discover"}
        onBack={goHome}
        editMode={editMode}
      />
      <span>Hello add Discover sutff plz</span>
    </div>
  );
}
